import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import './Header.css';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    
    // Handle scroll events to change header style
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        
        window.addEventListener('scroll', handleScroll);
        
        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    // Close menu when clicked outside
    useEffect(() => {
        const closeMenu = () => setMenuOpen(false);
        
        if (menuOpen) {
            document.addEventListener('click', closeMenu);
        }
        
        return () => {
            document.removeEventListener('click', closeMenu);
        };
    }, [menuOpen]);
    
    // Close menu when route changes
    useEffect(() => {
        setMenuOpen(false);
    }, [location]);
    
    // Toggle mobile menu
    const toggleMenu = (e) => {
        e.stopPropagation();
        setMenuOpen(!menuOpen);
    };
    
    // Check if link is active
    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };
    
    // Handle navigation with scrolling to top
    const handleNavigation = (e, path) => {
        e.preventDefault();
        navigate(path);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
    return (
        <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <Link 
                    to="/" 
                    className="logo"
                    onClick={(e) => handleNavigation(e, "/")}
                >
                    <FontAwesomeIcon icon={faLaptopCode} className="logo-icon" />
                    <span>Vishnu Ajit</span>
                </Link>
                
                <button className="mobile-menu-btn" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
                </button>
                
                <nav className={menuOpen ? 'open' : ''} onClick={(e) => e.stopPropagation()}>
                    <ul>
                        <li>
                            <a 
                                href="/"
                                className={isActive('/')} 
                                onClick={(e) => handleNavigation(e, "/")}
                            >
                                Home
                            </a>
                        </li>
                        <li>
                            <a 
                                href="/about"
                                className={isActive('/about')} 
                                onClick={(e) => handleNavigation(e, "/about")}
                            >
                                About
                            </a>
                        </li>
                        <li>
                            <a 
                                href="/contact"
                                className={isActive('/contact')} 
                                onClick={(e) => handleNavigation(e, "/contact")}
                            >
                                Contact
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;